import { get as _get } from 'lodash';

import { STATUS, PROPS } from './constants';


export default (activeDispenseAttempt) => {
  const isContainerApproved = _get(activeDispenseAttempt, 'review.approveContainer');
  const isPrescriptionApproved = _get(activeDispenseAttempt, 'review.approvePrescription');

  const isApproved = _get(activeDispenseAttempt, 'review.approveContainer') && _get(activeDispenseAttempt, 'review.approvePrescription');
  const isConsultationRequested = _get(activeDispenseAttempt, 'prescriptionFill.consultReq');

  if (isApproved) return PROPS[STATUS.APPROVED];
  else if (isApproved === false) return (() => {
    return {
      ...PROPS[STATUS.REJECTED],
      title: `${isPrescriptionApproved ? 'Container' : 'Prescription'} Rejected`,
    };
  })();
  else if (isConsultationRequested) return PROPS[STATUS.CONSULTATION_REQUESTED];
  else return PROPS[STATUS.UNIDENTIFIABLE];
};
